import {  Link as RouterLink } from "react-router-dom";
import {  FormControl, Box, Typography, Link, TextField, Button } from "@mui/material";
import ArrowCircleLeftOutlinedIcon from '@mui/icons-material/ArrowCircleLeftOutlined';
import PopOverCTA from "../../shared_elements/components/PopOverCTA";
const AssetsMenuList = ({pageLabel='', btnText='Supplements'}) => {

    return (
        <FormControl className="lease-menu-list-container">
            <Box className="lease-list-title" sx={{ marginBottom: '3px', marginLeft:'2px' }}>
                <Link component={RouterLink} to="/assets" sx={{ display: "flex", alignItems: "center", fontFamily: "Roboto", textDecoration: "none", cursor: "pointer", marginLeft: "-4px" }} >
                    <ArrowCircleLeftOutlinedIcon />
                    <Typography sx={{ fontSize: "14px", fontWeight: "bold", paddingLeft: "5px", textDecoration: "underline", }} > Assets List </Typography>
                </Link>
            </Box>
        </FormControl>
    );
};

export default AssetsMenuList;
